import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { ThinCheckbox } from 'components/common/Styles';

const StateTransitionUserGroupItemComponent = ({ userGroup, stateTransition, dispatch, changedStateTransitionsPermission }) => {
  const [checkedValue, setCheckedValue] = useState(false);

  useEffect(() => {
    const isChecked = stateTransition.userGroups.filter(x => x.userGroupId === userGroup.id);
    if (isChecked && isChecked[0]) setCheckedValue(true);
    else setCheckedValue(false);
  }, [stateTransition.userGroups, userGroup.id]);

  useEffect(() => {
    if (changedStateTransitionsPermission !== undefined) setCheckedValue(changedStateTransitionsPermission);
  }, [changedStateTransitionsPermission]);

  const onChangeChecked = event => {
    dispatch({
      type: 'OnChangeStateTransitionsPermission',
      stateTransitionId: stateTransition.id,
      userGroupId: userGroup.id,
      value: event.target.checked
    });
  };

  return (
    <TableCell padding='none' align='center' key={userGroup.userGroupId}>
      <ThinCheckbox checked={checkedValue} onChange={onChangeChecked} />
    </TableCell>
  );
};

StateTransitionUserGroupItemComponent.propTypes = {
  userGroup: PropTypes.object.isRequired,
  stateTransition: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  changedStateTransitionsPermission: PropTypes.bool
};

export default memo(StateTransitionUserGroupItemComponent);
